import React from 'react'
import { styled, s } from '@vega/styled'

import NeoLogo from '@vega/components/src/assets/images/neo-logo.png'

const Container = styled.div(
  s('relative flex flex-column pr-12 pt-16', {
    width: '596px',
    flexShrink: 0,
    paddingLeft: 80,
  })
)
const Title = styled.h2(s('text-5xl font-semibold text-white m-0'))
const Description = styled.p(s('text-2xl text-grey-300'))

const WelcomeSection = () => (
  <Container>
    <img src={NeoLogo} width={128} height={47} style={s('mb-24')} />
    <Title>Welcome to Neo Mortgage</Title>
    <Description>
      Collaborate with your mortgage broker to achieve your financial dreams
    </Description>
  </Container>
)

export { WelcomeSection }
